<template>
  <div :class="$style.wrapper">
    <h1 :class="$style.title">Проверьте почту</h1>
    <p :class="$style.subtitle">
      Введите код из письма, отправленного<br />на указанный ранее адрес:
    </p>

    <div :class="$style.codeRow" @click="focusCurrent">
      <input
        v-for="(v, i) in code"
        :key="i"
        :ref="(el) => (inputs[i] = el)"
        :class="[
          $style.codeCell,
          i === activeIndex && $style.codeCellActive,
          { [$style.wrongCode]: this.wrongCode },
        ]"
        type="text"
        inputmode="numeric"
        pattern="[0-9]*"
        autocomplete="one-time-code"
        maxlength="1"
        v-model="code[i]"
        @focus="activeIndex = i"
        @input="onInput(i)"
        @keydown="onKey(i, $event)"
        @paste="onPaste($event)"
      />
    </div>

    <div v-if="leftSec > 0" :class="$style.resend">
      Отправить повторно через {{ mm }}:{{ ss }}
    </div>
    <button v-else :class="$style.resendLink" @click="resend">
      Отправить код еще раз
    </button>
  </div>
</template>

<script>
import { EMAIL_ZONE_MESSAGE, isRuZoneEmail } from "@/utils/emailZone"

export default {
  name: "CheckEmail",
  data() {
    return {
      code: ["", "", "", "", "", ""],
      activeIndex: 0,
      inputs: [],
      mbHandler: null,
      leftSec: 180,
      initialSec: 180,
      timerId: null,
      wrongCode: false,
      payload: null,
      edit: false,
    }
  },
  computed: {
    completed() {
      return this.code.every((c) => c && c.length === 1)
    },
    mm() {
      const m = Math.floor(this.leftSec / 60)
      return String(m)
    },
    ss() {
      const s = this.leftSec % 60
      return String(s).padStart(2, "0")
    },
  },
  methods: {
    focusCurrent() {
      this.$nextTick(() => this.inputs[this.activeIndex]?.focus())
    },
    sanitizeChar(ch) {
      const m = String(ch || "").match(/[0-9]/)
      return m ? m[0] : ""
    },
    onInput(i) {
      const raw = this.code[i]
      if (raw && raw.length > 1) {
        this.onPaste({
          clipboardData: { getData: () => raw },
          preventDefault: () => {},
        })
        return
      }
      const one = this.sanitizeChar(raw)
      this.code[i] = one
      if (one && i < this.code.length - 1) {
        this.activeIndex = i + 1
        this.focusCurrent()
      }
      this.updateMB()
    },
    onKey(i, e) {
      if (e.key === "Backspace") {
        this.wrongCode = false
        if (this.code[i]) {
          this.code[i] = ""
        } else if (i > 0) {
          this.activeIndex = i - 1
          this.$nextTick(() => {
            this.inputs[this.activeIndex]?.focus()
            this.code[this.activeIndex] = ""
          })
        }
        this.updateMB()
      } else if (e.key === "Delete") {
        this.wrongCode = false
        this.code[i] = ""
        this.updateMB()
      } else if (e.key === "ArrowLeft" && i > 0) {
        this.activeIndex = i - 1
        this.focusCurrent()
      } else if (e.key === "ArrowRight" && i < this.code.length - 1) {
        this.activeIndex = i + 1
        this.focusCurrent()
      }
    },
    onPaste(e) {
      const text =
        (e.clipboardData || window.clipboardData)?.getData("text") || ""
      const chars = (text.match(/[0-9]/g) || []).slice(0, 6)
      if (!chars.length) return
      if (e.preventDefault) e.preventDefault()
      for (let k = 0; k < 6; k++) this.code[k] = chars[k] || ""
      this.activeIndex =
        Math.min(chars.length, 6) - 1 >= 0 ? Math.min(chars.length, 6) - 1 : 0
      this.updateMB()
      this.focusCurrent()
    },
    updateMB() {
      const mb = window.Telegram?.WebApp?.MainButton
      if (!mb) return
      mb.setText("Отправить на модерацию")
      if (this.completed) {
        mb.textColor = "#ffffff"
        mb.color = "#eb5a0a"
        mb.enable()
      } else {
        mb.textColor = "#B9B9BB"
        mb.color = "#E8E8EA"
        mb.enable()
      }
      mb.show()
    },
    async submit() {
      if (!this.completed) return
      const value = this.code.join("")
      const response = await this.$store.dispatch("checkCode", value)
      if (response?.status === 403) {
        this.wrongCode = true
        alert("Неправильный код!")
      } else {
        this.wrongCode = false
        if (this.edit) {
          await this.$store.dispatch("userUpdate", this.payload)
        } else {
          const payload = {
            ...this.$store.state.userInfoUpdate,
            created_at: new Date().toISOString().slice(0, 19) + "Z",
          }
          await this.$store.dispatch("userUpdate", payload)
        }
        if (this.edit) {
          if (response.status === 200) {
            this.$router.push({ path: "/personal-info" })
          }
        } else {
          if (response.status === 200) {
            this.$router.push({ path: "/" })
          }
        }
      }
    },
    startTimer() {
      if (this.timerId) clearInterval(this.timerId)
      this.timerId = setInterval(() => {
        if (this.leftSec > 0) this.leftSec -= 1
        if (this.leftSec <= 0) {
          this.leftSec = 0
          clearInterval(this.timerId)
          this.timerId = null
        }
      }, 1000)
    },
    async resend() {
      // Зона почты могла стать запрещённой после первой отправки кода
      const email = this.payload?.email
      if (email && !isRuZoneEmail(email)) {
        const tg = window.Telegram?.WebApp
        if (tg?.showPopup) {
          tg.showPopup({
            title: "Внимание",
            message: EMAIL_ZONE_MESSAGE,
            buttons: [{ type: "close", text: "Понятно" }],
          })
        } else {
          window.alert(EMAIL_ZONE_MESSAGE)
        }
        return
      }
      await this.$store.dispatch("registerStart", this.payload)
      this.leftSec = this.initialSec
      this.startTimer()
    },
  },
  mounted() {
    this.payload = window.history.state?.payload || null
    this.edit = window.history.state?.edit
    this.focusCurrent()
    const mb = window.Telegram?.WebApp?.MainButton
    if (mb) {
      this.mbHandler = () => this.submit()
      mb.onClick(this.mbHandler)
      this.updateMB()
    }
    this.startTimer()
  },
  beforeUnmount() {
    const tg = window.Telegram?.WebApp
    const mb = tg?.MainButton
    if (mb) {
      mb.hide()
      if (this.mbHandler) mb.offClick(this.mbHandler)
    }
    if (this.timerId) clearInterval(this.timerId)
  },
}
</script>

<style lang="scss" module>
.wrapper {
  min-height: 100vh;
  padding: 1.875rem 1rem calc(9rem + env(safe-area-inset-bottom));
  justify-items: center;
  gap: 1rem;
  background: #fff;
  text-align: center;
  -webkit-tap-highlight-color: transparent;
}

.title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #161616;
  text-align: center;
}

.subtitle {
  text-align: center;
  color: #9b9ba1;
  font-size: 1rem;
  line-height: 1.4;
  margin: 0.5rem 0 0 0;
}

.codeRow {
  display: grid;
  grid-template-columns: repeat(6, 44px);
  gap: 10px;
  margin-top: 2.5rem;
  justify-content: center;
}

.codeCell {
  box-sizing: border-box;
  width: 44px;
  height: 52px;
  border-radius: 12px;
  border: 2px solid #eeeeef;
  background: #ffffff;
  text-align: center;
  font-size: 24px;
  color: #161616;
  outline: none;
  padding: 0;
  line-height: 52px;
  appearance: none;
}

.codeCellActive {
  border-color: #000000;
}

.wrongCode {
  border-color: #d30000 !important;
}

.resend {
  margin-top: 1.5rem;
  color: #9b9ba1;
  font-size: 1rem;
  text-align: center;
}

.resendLink {
  margin-top: 1.5rem;
  background: transparent;
  border: 0;
  color: #eb5a0a;
  font-size: 1rem;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
